

const link:any = {
  defaultProps: {
    underline: "none",
    color: "inherit",
  },
};

export default link;
